import React from "react";
import MainCard from "../../../components/MainCard";
import { Grid } from "@mui/material";

const SkippedTestsReport = () => {
  return <MainCard content={true}>Skipped Tests Report - Coming Soon</MainCard>;
};

export default SkippedTestsReport;
